<div class="card kpi-yellow">
    <div class="card-body kpi-card">
        <h5 class="card-title">
            Différence de prix
            <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
               matTooltip="Différence de prix au m² entre votre projet et {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}">
            </i>
        </h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                {{ ((favorite.price / favorite.square) / favorite.advice_price * 100) - 100 | number:'1.0-0' }} %
            </ng-container>
        </p>
    </div>
</div>

